import { HubConnectionBuilder, HubConnection, HttpTransportType, LogLevel, HubConnectionState, RetryContext } from '@microsoft/signalr';
import { IChatMessage } from '../../model/chatmessage';
import { setTimeout } from 'timers';



export class SignalRConnection {
    static logout = null
    private static manuallyStopped = false;

    private static _connection: HubConnection = null;

    public static OnJwtTokenExpired: () => void;
    public static OnUserConnected: (sub: string, connId: string) => void;
    public static OnUserDisconnected: (sub: string) => void;

    public static getConnection(accessToken: string) {
        if (SignalRConnection._connection == null) {
            SignalRConnection.initConnection(accessToken);
        }
        return SignalRConnection._connection;
    }

    public static async initConnection(accessToken: string) {

        let _url = '/signalR?build=0&version=0';
        SignalRConnection._connection = new HubConnectionBuilder()
            .withUrl(_url, {
                transport: HttpTransportType.WebSockets,
                accessTokenFactory: () => accessToken
            })
            .configureLogging(LogLevel.Trace)
            .withAutomaticReconnect(SignalRConnection.retryPolicy)
            .build();

        SignalRConnection.startConnection();
        SignalRConnection.registerHubHandler();
    }
    private static hasSessionError = (err: Error) => {
        return err && err.message && err.message.toLocaleLowerCase().indexOf('session expired') >= 0;
    }
    private static callLogout = () => {
        if (SignalRConnection.logout !== null && typeof SignalRConnection.logout === 'function') {
            SignalRConnection.logout();
        }
    }
    private static retryPolicy = {
        nextRetryDelayInMilliseconds: (retryContext: RetryContext) => {
            // retryContext.elapsedMilliseconds
            // tempo passato durante il quale sto provando a riconnettermi

            console.warn(`signalr retryReason: ${JSON.stringify(retryContext.retryReason)}`);

            if (retryContext.retryReason) {
                if (SignalRConnection.hasSessionError(retryContext.retryReason)) {
                    SignalRConnection.callLogout();
                    return null;
                }
            }

            if (retryContext.elapsedMilliseconds < 60 * 1000) {
                return 5 * 1000
            }
            else if (retryContext.elapsedMilliseconds < 10 * 60 * 1000) {
                return 60 * 1000
            }
            else {
                //fermo i tentativi
                return null;
            }

        }
    }
    private static startConnection = () => {
        SignalRConnection.manuallyStopped = false;
        if (SignalRConnection._connection !== null)
            SignalRConnection._connection
                .start()
                .catch((err: any) => {
                    //console.error(err.toString());
                    SignalRConnection.retryStartConnection();
                });
    }

    private static retryStartConnection = () => {
        if (!SignalRConnection.manuallyStopped)
            setTimeout(() => { SignalRConnection.startConnection() }, 5 * 1000)
    }

    public static stopConnection = () => {
        SignalRConnection.manuallyStopped = true;
        if (SignalRConnection._connection !== null)
            SignalRConnection._connection.stop();
    }

    public static registerConnectionHandler = (event: string, handler: (...args: any[]) => void) => {
        if (SignalRConnection._connection !== null)
            SignalRConnection._connection
                .on(event, handler);
    }

    public static removeConnectionHandler = (event) => {
        if (SignalRConnection._connection !== null)
            SignalRConnection._connection
                .off(event);
    }

    private static registerHubHandler() {

        if (SignalRConnection._connection !== null) {
            SignalRConnection._connection.onclose((err) => {
                console.warn('### connection closed: ' + JSON.stringify(err));
                if (err && err.message && err.message.toLowerCase().indexOf('session expired') >= 0) {
                    if (SignalRConnection.OnJwtTokenExpired !== null && typeof SignalRConnection.OnJwtTokenExpired === 'function') {
                        SignalRConnection.OnJwtTokenExpired();
                    }
                } else {

                    SignalRConnection.retryStartConnection();
                }
            })

            SignalRConnection._connection
                .on("SendMessageToAdmin", (message: IChatMessage, Oauth0UserId: string) => {
                    console.info('Lo User....................................:' + Oauth0UserId);
                    console.info('Ha iniviato il testo.......................:' + message);
                    //this.UpdateStoreMessages(Oauth0UserId, message);
                });
            SignalRConnection._connection
                .on("UserConnected", (sub: string, connId: string) => {
                    console.info('Lo User[' + sub + '] si è connesso');
                    if (SignalRConnection.OnUserConnected !== null && typeof SignalRConnection.OnUserConnected === 'function') {
                        SignalRConnection.OnUserConnected(sub, connId);
                    }

                });
            SignalRConnection._connection
                .on("UserDisconnected", (sub: string, connId: string) => {
                    console.info('Lo User[' + sub + '] si è disconnesso');
                    if (SignalRConnection.OnUserDisconnected !== null && typeof SignalRConnection.OnUserDisconnected === 'function') {
                        SignalRConnection.OnUserDisconnected(sub);
                    }
                });

            SignalRConnection._connection
                .on("onDisconnect", (sub: string, connId: string) => {
                    console.info('connection closed');
                });

            setInterval(function () {
                if (SignalRConnection._connection.state === HubConnectionState.Connected) {
                    SignalRConnection._connection.send("ping");
                }
            }, 5000);
            SignalRConnection._connection.onreconnecting((error) => {
                console.assert(SignalRConnection._connection.state === HubConnectionState.Reconnecting);
            });
        }
    }
}